module.exports = __webpack_public_path__ + "static/img/aqzs41.b1835492.jpg";